import React, { Component } from "react";
import { Spin } from "antd";
import LabDetailsTabView from "./LabDetailsTabView";
import { getLabDetails } from "../../../services";
import { showErrorNotification, getProp, strings } from "../../../helpers";

/**
 * @function getCurrentTabName
 * @params pathName
 * @description It will return the current active tab
 */
const getCurrentTabName = pathName => {
  let currentPage = null;
  // get pathName like '/settings/vitals'
  // find the number of `/` and get the array length
  const pathLength = (pathName.match(new RegExp("/", "g")) || []).length;
  // if pathName has only 1 '/'
  if (pathLength === 1) {
    currentPage = pathName.replace("/", "");
  } else if (pathLength === 2) {
    const path1 = pathName.substring(1).split("/")[0];
    currentPage = path1;
  } else {
    // if pathName has 2 '/'  like '/settings/network
    const path = pathName.substring(1).split("/")[2];

    currentPage = path;
  }

  return currentPage;
};

export default class LabDetailsTabsContainer extends Component {
  constructor(props) {
    super(props);
    const { labId } = this.props.match.params;
    this.state = { isProcessing: false, labId: labId, details: {} };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // get pathname like '/settings/vitals' from url
    const pathName = nextProps.location.pathname;

    const currentPage = getCurrentTabName(pathName);
    if (!prevState.currentPath !== currentPage) {
      return { currentPath: currentPage };
    }
    return null;
  }

  componentDidMount() {
    const { labId } = this.props.match.params;

    this.setState({ labId, isProcessing: true }, () => {
      this.getLabInfo();
    });
  }

  /**
   * @function getLabInfo.
   * @description it will get the lab info
   */
  getLabInfo = () => {
    const { labId } = this.state;
    this.setState({ isProcessing: true });
    getLabDetails(labId)
      .then(response => {
        this.setState({ isProcessing: false });
        const getErrors = getProp(["data", "errors"]);
        const getSuccess = getProp(["data", "success"]);
        const getDataSuccess = getProp(["data", "data"]);

        if (getSuccess(response)) {
          const details = getDataSuccess(response);

          this.setState({
            details,
            isProcessing: false
          });
        } else if (getErrors(response)) {
          const { errors } = response.data;

          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      })
      .catch(response => {
        const getErrors = getProp(["data", "errors"]);
        if (getErrors(response)) {
          const { errors } = response.data;
          let error = errors;
          if (Array.isArray(errors)) {
            error = errors[0];
          }
          showErrorNotification(error.title);
          this.setState({ details: [], isProcessing: false });
        }
      });
  };

  /**
   * @function refreshClinnicDetails
   * @desc it will refresh the details
   *
   */
  refreshLabDetails = labId => {
    this.setState({ labId, details: {} }, () => {
      this.getLabInfo();
    });
  };

  render() {
    const { currentPath, isProcessing, details, labId } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <div className="reputation-wrapper">
          <div className="content-container">
            {/* heading block start */}
            <div className="heading">
              <div className="left">{strings.dashboard.labDetails}</div>
            </div>
            {/* heading block end */}
            {details && (
              <LabDetailsTabView
                refreshLabDetails={this.refreshLabDetails}
                currentPath={currentPath}
                details={details}
                labId={labId}
              />
            )}
          </div>
        </div>
      </Spin>
    );
  }
}
